// https://html.spec.whatwg.org/multipage/input.html#email-state-(type=email)
export const emailRegex = new RegExp(
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
)

export const ERROR_NO_ACCESS = 'Access denied. Contact the owner of this application if you need access.'
export const ERROR_INVALID_REDIRECT_URL = 'This redirect address is not valid. Contact the application owner for help.'
export const ERROR_LOGIN = "We couldn't sign you in. Try again, or visit Help if the problem continues."
